import { useLang } from 'hooks/lang';

import { Column } from 'components/Blocks';
import { MonetaryInput } from 'components/Inputs';

import { calculateAmountLeftToInvoice, isInvoiceValueOk } from '../../utils';
import { formatCurrency } from 'utils/text';

import { LoadedPackage } from '../../types';

interface State {
  value: string;
}

interface Props {
  state: State;
  dispatch: (v: State) => void;
  data: LoadedPackage;
}

export function PackageInvoiceValue({ state, dispatch, data }: Props): JSX.Element {
  const { t } = useLang();

  const availableAmount = calculateAmountLeftToInvoice(data);

  const selectedValueIsOk = isInvoiceValueOk(data, state.value);

  return (
    <Column gap="2">
      <MonetaryInput
        currency={data.currency}
        currencyDisabled
        value={state.value}
        label={t('invoice-value')}
        onChangeDirect={(value) => dispatch({ value })}
        wrapperClassName={
          selectedValueIsOk ? '' : 'border-destructive focus-within:border-destructive'
        }
      />

      <span className="text-xs text-destructive">
        {t('this-package-has-left-to-be-invoiced', {
          value: formatCurrency(availableAmount, data.currency),
        })}
      </span>
    </Column>
  );
}
